'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tunnelSelector = exports.getTunnel = undefined;

var _reselect = require('reselect');

var _reducer = require('./reducer');

/**
 * Gets the tunnel from the state
 * @param {Map<*, *>} state The app state
 * @returns {Record} The tunnel record
 */


// Tunnel type
var getTunnel = exports.getTunnel = function getTunnel(state) {
  return state.getIn(['tunnel'], _reducer.defaultTunnel);
};

/**
 * The memoized tunnel selector.
 */

var tunnelSelector = exports.tunnelSelector = (0, _reselect.createSelector)([getTunnel], function (tunnel) {
  return tunnel;
});
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-tunnel/dist/main/selectors.js
// module id = 531
// module chunks = 0